
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Ensure we have the correct root element
const root = document.getElementById('root');

if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} else {
  console.error("Root element not found! Check the DOM structure.");
  
  // Attempt to create a root element if it's missing
  const bodyElement = document.body;
  if (bodyElement) {
    const newRoot = document.createElement('div');
    newRoot.id = 'root';
    bodyElement.appendChild(newRoot);
    console.log("Created new root element");
    
    ReactDOM.createRoot(newRoot).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  }
}

// Add explicit HMR handling
if (import.meta.hot) {
  import.meta.hot.accept();
}
